import React from 'react'

const footer = () => {
  return (
   <footer className="footer">© 2025 Embroidery App</footer>
  )
}

export default footer